import { Table, TableBody, TableHeader } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { MEMBER_GROUPS_HEADER } from '@bo-constants/memberGroups';
import { MemberGroupsContext } from '@bo-hooks/memberGroups/useMemberGroupsContext';
import { MemberGroupsRow } from '@library/components/table/rows/MemberGroupsRow';
import { NoResults } from '@library/components/NoResults';
import { useContext } from 'react';

export const MemberGroupsTable = () => {
  const {
    // filters,
    isLoading,
    openModal,
    setSortBy,
    sortBy,
    memberGroups,
    setCurrentMemberGroup
  } = useContext(MemberGroupsContext);

  const menuActions = {
    onEdit: (id: string) => openModal('edit', Number(id))
  };

  if (isLoading) {
    return <Loading loadingMessage="Loading Member Groups" />;
  }

  if (!memberGroups?.length) {
    return (
      <NoResults
        className="m-0"
        label="Use the search bar to search by name or description"
      />
    );
  }

  return (
    <Table>
      <div className="flex flex-col overflow-x-auto" data-testid="MemberGroups">
        <TableHeader
          headers={MEMBER_GROUPS_HEADER}
          sort={sortBy}
          onSort={setSortBy}
        />
        <TableBody>
          {memberGroups.map((memberGroup) => (
            <MemberGroupsRow
              key={memberGroup.id}
              memberGroup={memberGroup}
              onRowClick={() => setCurrentMemberGroup(memberGroup)}
              menuActions={menuActions}
            />
          ))}
        </TableBody>
      </div>
    </Table>
  );
};
